/* global inflationMonth bonusMonth updateCashlowDatesUrl fetchPayratesUrl storePayrateUrl updatePayrateUrl deletePayrateUrl */
/* global eventStartDate eventEndDate */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import 'react-datepicker/dist/react-datepicker.css';
import App from 'App';
import { isNull, isString } from 'lodash';
import DatePicker from 'react-datepicker';

import WorkforceAssumptionPayrates from './WorkforceAssumptionPayrates';
import WorkforceAssumptionRecruitmentStatuses from './WorkforceAssumptionRecruitmentStatuses';

import Button from 'CommonComponents/Button';
import ContentListItem from 'CommonComponents/ContentListItem';

import useApiRequest from 'Hooks/useApiRequest';
import { useToast } from 'Hooks/useToast';

const getInitialDate = (month) => {
    if (isNull(month) || month === '' || month === undefined) {
        return null;
    }

    return new Date(new Date().getFullYear(), month - 1, 1);
};

export default function WorkforceAssumptionIndex(props) {
    const [editMode, setEditMode] = useState(false);
    const [inflationMonth, setInflationMonth] = useState(getInitialDate(props.inflationMonth));
    const [bonusMonth, setBonusMonth] = useState(getInitialDate(props.bonusMonth));
    const [payrates, setPayrates] = useState([]);
    const [defaultPercentage, setDefaultPercentage] = useState({});

    const toast = useToast();
    const payratesRequest = useApiRequest({ url: props.fetchPayratesUrl });
    const updateDatesRequest = useApiRequest({ url: props.updateCashlowDatesUrl });

    useEffect(() => {
        fetchPayrates();
    }, []);

    const fetchPayrates = () => {
        payratesRequest.get().then((res) => {
            const { data } = res;

            setPayrates(data.payrates);
            setDefaultPercentage(data.defaultPercentage);
        });
    };

    const changeInflationMonth = (e) => {
        setInflationMonth(e);
    };
    const changeBonusMonth = (e) => {
        setBonusMonth(e);
    };

    const formatDate = (date) => {
        if (!date) {
            return null;
        }

        if (isString(date) || isNull(date)) {
            date = getInitialDate(date);
        }

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const updateCashflowDates = () => {
        const data = {
            inflation_date: formatDate(inflationMonth),
            bonus_date: formatDate(bonusMonth),
        };

        updateDatesRequest
            .put(data)
            .then((res) => {
                setInflationMonth(getInitialDate(res.data.inflation_month));
                setBonusMonth(getInitialDate(res.data.bonus_month));
                fetchPayrates();

                toast.success($t('Dates updated successfully'));
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || $t('Something went wrong while updating the dates'));
            })
            .finally(() => {
                setEditMode(false);
            });
    };

    return (
        <>
            <div className="tw-space-y-2">
                <div className="tw-grid tw-grid-cols-1 tw-gap-2">
                    <div>
                        <div className="tw-px-6 tw-py-6.5 tw-rounded-lg tw-bg-white tw-shadow-primary">
                            <div className="tw-flex tw-justify-between tw-items-start">
                                <h3 className="table__header">{$t('Cashflow Dates')}</h3>
                            </div>
                            <div className="tw-flex tw-gap-x-1.5 tw-justify-between">
                                <div className="tw-mt-3 tw-rounded-lg tw-w-1/2">
                                    <ul className="tw-flex tw-flex-col tw-gap-y-3 tw-text-sm">
                                        <ContentListItem
                                            title={$t('Inflation Calculation Month')}
                                            info={$t('Inflation will be implemented in the month selected here')}
                                            classNames="tw-items-center"
                                        >
                                            {!!editMode && (
                                                <div className="simple-month tw-flex tw-items-center tw-gap-x-2">
                                                    <DatePicker
                                                        selected={inflationMonth}
                                                        onChange={(date) => changeInflationMonth(date)}
                                                        dateFormat="MMMM"
                                                        showMonthYearPicker
                                                        locale="en"
                                                        className="tw-border tw-rounded-md tw-p-2 tw-text-center tw-w-40 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-400"
                                                    />
                                                </div>
                                            )}
                                            {!editMode && (
                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                    <span className="tw-px-3 tw-font-bold">
                                                        {/* eslint-disable-next-line no-restricted-syntax -- date formatting, not a number: month names are out of this scope. */}
                                                        {inflationMonth ? inflationMonth.toLocaleString('en-US', { month: 'long' }) : '-'}
                                                    </span>
                                                </div>
                                            )}
                                        </ContentListItem>
                                        <ContentListItem
                                            title={$t('Yearly Bonus Month ')}
                                            info={$t(
                                                'Yearly Bonus will be calculated for the year up to the month selected here. If a position is in place for less than a year the amount will be pro-rata',
                                            )}
                                            classNames="tw-items-center"
                                        >
                                            {!!editMode && (
                                                <div className="simple-month tw-flex tw-items-center tw-gap-x-2">
                                                    <DatePicker
                                                        selected={bonusMonth}
                                                        onChange={(date) => changeBonusMonth(date)}
                                                        dateFormat="MMMM"
                                                        showMonthYearPicker
                                                        locale="en"
                                                        className="tw-border tw-rounded-md tw-p-2 tw-text-center tw-w-40 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-400"
                                                    />
                                                </div>
                                            )}
                                            {!editMode && (
                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                    <span className="tw-px-3 tw-font-bold">
                                                        {/* eslint-disable-next-line no-restricted-syntax -- date formatting, not a number: month names are out of this scope. */}
                                                        {inflationMonth ? bonusMonth.toLocaleString('en-US', { month: 'long' }) : '-'}
                                                    </span>
                                                </div>
                                            )}
                                        </ContentListItem>
                                    </ul>
                                </div>

                                <div className="tw-self-end tw-mt-auto">
                                    {!!editMode && (
                                        <>
                                            <Button className="tw-mr-4" variant="secondary" onClick={() => setEditMode(false)}>
                                                {$t('Cancel')}
                                            </Button>
                                            <Button variant="primary" onClick={updateCashflowDates}>
                                                {$t('Save')}
                                            </Button>
                                        </>
                                    )}
                                    {!editMode && (
                                        <Button variant="secondary" onClick={() => setEditMode(true)}>
                                            {$t('Edit')}
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {Object.keys(defaultPercentage).length > 0 && (
                <WorkforceAssumptionPayrates
                    payrates={payrates}
                    defaultPercentage={defaultPercentage}
                    fetchPayrates={fetchPayrates}
                    storeUrl={props.storeUrl}
                    updatePayrateUrl={props.updatePayrateUrl}
                    deletePayrateUrl={props.deletePayrateUrl}
                    eventStartDate={props.eventStartDate}
                    eventEndDate={props.eventEndDate}
                />
            )}
            {props.recruitmentStatusUrls && (
                <WorkforceAssumptionRecruitmentStatuses urls={props.recruitmentStatusUrls} canManage={props.canManageRecruitmentStatuses} />
            )}
        </>
    );
}

if (document.getElementById('WorkforceAssumption')) {
    var rootEl = document.getElementById('WorkforceAssumption');
    ReactDOM.render(
        <App>
            <WorkforceAssumptionIndex
                inflationMonth={inflationMonth}
                bonusMonth={bonusMonth}
                updateCashlowDatesUrl={updateCashlowDatesUrl}
                fetchPayratesUrl={fetchPayratesUrl}
                storeUrl={storePayrateUrl}
                updatePayrateUrl={updatePayrateUrl}
                deletePayrateUrl={deletePayrateUrl}
                eventStartDate={eventStartDate}
                eventEndDate={eventEndDate}
                recruitmentStatusUrls={rootEl.dataset.recruitmentStatusUrls ? JSON.parse(rootEl.dataset.recruitmentStatusUrls) : null}
                canManageRecruitmentStatuses={rootEl.dataset.canManageRecruitmentStatuses === 'true'}
            />
        </App>,
        rootEl,
    );
}
